import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import { FILES_URL } from "helpers/url_helper"
import PropTypes from "prop-types"

const LocationHeaderCard = ({ location, toggleEditModal }) => {
    if (!location) return null

    // Helper to safely get logo URL
    const logoUrl =
        location.logo_files?.length > 0
            ? `${FILES_URL}${location.logo_files[0].file_name}`
            : null

    // Badge Styles (Customizing colors to match your image)
    const badgeStyle = {
        padding: "6px 12px",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "600",
        marginRight: "8px",
        color: "#fff",
        display: "inline-block",
    }

    return (
        <Card
            style={{
                backgroundColor: "#3C3C3C", // Dark gray background
                borderRadius: "15px", // Sharp or slightly rounded
                marginBottom: "20px",
                border: "none",
                color: "#fff",
            }}
        >
            <CardBody className="p-3">
                <Row className="align-items-center">
                    {/* LEFT SIDE: Logo & Location Info */}
                    <Col md={5} className="d-flex align-items-center">
                        {/* Circular Logo with Gold Border */}
                        <div
                            style={{
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                border: "3px solid #FFCA5C", // Gold border
                                backgroundColor: "#000",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "20px",
                                overflow: "hidden",
                                flexShrink: 0,
                            }}
                        >
                            {logoUrl ? (
                                <img
                                    src={logoUrl}
                                    alt="Logo"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            ) : (
                                // Fallback icon if no logo
                                <i className="bx bxs-car" style={{ fontSize: "30px", color: "#fff" }}></i>
                            )}
                        </div>

                        <div>
                            <h2
                                className="mb-1"
                                style={{ color: "#FFCA5C", fontWeight: "bold", fontSize: "24px" }}
                            >
                                {location.location_name || "Location Name"}
                            </h2>
                            <p className="mb-0 text-white" style={{ fontSize: "14px" }}>
                                {/* Use address if available, or placeholder */}
                                {location.location_address || ""}
                            </p>
                        </div>
                    </Col>

                    {/* RIGHT SIDE: Manager, Badges & Close */}
                    <Col md={6} className="d-flex flex-column align-items-start justify-content-center pe-4">

                        {/* === TOP ROW: Manager Section & Edit Button === */}
                        <div className="d-flex align-items-center mb-3">
                            {/* Manager Section */}
                            <div className="d-flex align-items-center me-4">
                                <img
                                    src="https://placehold.co/100x100" // Replace with actual manager image url if available
                                    alt="Manager"
                                    className="rounded-circle"
                                    style={{ width: "45px", height: "45px", marginRight: "10px", border: "2px solid #FFCA5C" }}
                                />
                                <div className="text-end">
                                    <h6
                                        className="mb-0"
                                        style={{ color: "#FFCA5C", fontSize: "15px" }}
                                    >
                                        {location?.account_manager?.full_name || "N/A"}
                                    </h6>
                                    <small className="text-muted">Manager</small>
                                </div>
                            </div>
                        </div>


                        {/* === BOTTOM ROW: Badges Container === */}
                        {/* Added justify-content-end to ensure badges align right */}
                        <div className="d-flex align-items-center justify-content-end flex-wrap">
                            {/* Active Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: location.is_active === 1 ? "#7BB64E" : "#bc3c3c" }}>
                                {location.is_active === 1 ? "Active" : "Inactive"}
                            </span>

                            {/* Invoicing Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: "#C13C37" }}>
                                {location.invoicing_type || "No Invoice"}
                            </span>

                            {/* Stage Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: "#5E5CE6" }}>
                                {location.stage || "Live"}
                            </span>

                            {/* Structure Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: "#FCA311" }}>
                                {location.operating_structure || "Non Lease"}
                            </span>

                            {/* Cash Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: "#4CAF50" }}>
                                {location.is_cash_accepted === 1 ? "Cash Accepted" : "No Cash"}
                            </span>

                            {/* Monthly Parking Badge */}
                            <span style={{ ...badgeStyle, backgroundColor: "#5E5CE6" }}>
                                {location.is_monthly_parking_active === 1 ? "Monthly Parking" : "No Monthly"}
                            </span>
                        </div>
                    </Col>

                    <Col md={1}>
                        {/* Edit Button (Placed next to manager in the top row) */}
                        <div style={{ cursor: "pointer" }}>
                            <button className="btn btn-sm btn-outline-light" onClick={toggleEditModal}>
                                <i className={`bx bx-edit`}></i> Edit
                            </button>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

LocationHeaderCard.propTypes = {
    location: PropTypes.object,
    onClose: PropTypes.func
}

export default LocationHeaderCard